export default function Hero() {
  const handleClick = (e: React.MouseEvent<HTMLAnchorElement>, href: string) => {
    e.preventDefault();
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section id="hero" className="relative w-full overflow-hidden pt-[72px]">
      <div className="absolute inset-0 bg-gradient-to-b from-background-100/80 via-background-50 to-background-50"></div>

      <div className="relative w-full max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row items-center gap-8 md:gap-12 py-10 md:py-16 lg:py-20 min-h-[520px] md:min-h-[600px]">
          <div className="flex-1 w-full flex flex-col items-start gap-5 md:gap-6">
            <span className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-primary-100 text-primary-700 text-xs md:text-sm font-medium">
              <i className="ri-fire-line text-sm"></i>
              实时热议 · 每分钟更新
            </span>

            <h1 className="font-heading font-black text-3xl md:text-4xl lg:text-5xl text-foreground-950 leading-tight tracking-tight">
              吃瓜网51
              <br />
              <span className="text-primary-500">全网最热八卦爆料社区</span>
            </h1>

            <p className="font-heading text-lg md:text-xl text-foreground-600 font-semibold">
              加入吃瓜群众大本营，畅聊最新内幕
            </p>

            <div className="space-y-3">
              <p className="text-sm md:text-base text-foreground-600 leading-relaxed max-w-[560px]">
                吃瓜网51是国内领先的娱乐八卦与热点话题讨论平台，汇聚千万网友实时分享最新爆料、内幕消息和热门话题。无论是娱乐圈动态、社会热点还是生活趣闻，这里都是你获取第一手资讯和交流观点的最佳去处。
              </p>
              <p className="text-sm md:text-base text-foreground-600 leading-relaxed max-w-[560px]">
                平台每日更新海量内容，涵盖明星八卦、影视综艺、社会万象、情感故事等多元话题圈，让每位吃瓜群众都能找到志同道合的伙伴。
              </p>
            </div>

            <div className="flex flex-wrap items-center gap-5 md:gap-8">
              <div className="flex flex-col items-center">
                <span className="font-heading font-bold text-2xl md:text-3xl text-primary-500">50万+</span>
                <span className="text-xs md:text-sm text-foreground-500">日均活跃用户</span>
              </div>
              <div className="w-px h-8 bg-background-200"></div>
              <div className="flex flex-col items-center">
                <span className="font-heading font-bold text-2xl md:text-3xl text-accent-500">128万+</span>
                <span className="text-xs md:text-sm text-foreground-500">话题总数</span>
              </div>
              <div className="w-px h-8 bg-background-200"></div>
              <div className="flex flex-col items-center">
                <span className="font-heading font-bold text-2xl md:text-3xl text-secondary-500">3.6万+</span>
                <span className="text-xs md:text-sm text-foreground-500">今日新帖</span>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row gap-3 w-full sm:w-auto">
              <a
                href="#topics"
                onClick={(e) => handleClick(e, '#topics')}
                className="inline-flex items-center justify-center gap-2 px-7 py-3.5 rounded-lg bg-primary-500 text-white font-medium text-sm hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
              >
                <i className="ri-chat-smile-2-line text-lg"></i>
                立即加入讨论
              </a>
              <a
                href="#ranking"
                onClick={(e) => handleClick(e, '#ranking')}
                className="inline-flex items-center justify-center gap-2 px-7 py-3.5 rounded-lg border-2 border-background-300 text-foreground-700 font-medium text-sm hover:border-primary-300 hover:text-primary-600 transition-colors whitespace-nowrap cursor-pointer"
              >
                <i className="ri-fire-line text-lg"></i>
                浏览吃瓜热榜
              </a>
            </div>
          </div>

          <div className="flex-1 w-full flex items-center justify-center">
            <div className="relative w-full max-w-[520px] aspect-[4/3] rounded-2xl overflow-hidden bg-background-100">
              <img
                src="https://readdy.ai/api/search-image?query=Stylized%20artistic%20illustration%20of%20a%20vibrant%20Chinese%20online%20gossip%20community%20with%20warm%20red%20and%20coral%20tones%2C%20abstract%20network%20connections%20linking%20people%2C%20floating%20speech%20bubbles%20and%20news%20icons%2C%20watermelon%20motif%20subtle%20elements%2C%20modern%20flat%20design%20aesthetic%20with%20soft%20gradients%2C%20editorial%20quality%2C%20harmonious%20composition%2C%20warm%20atmosphere&width=1040&height=780&seq=hero-main-visual-01&orientation=landscape"
                alt="吃瓜网51八卦社区主视觉 - 网友热议最新爆料"
                className="w-full h-full object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/20 via-transparent to-transparent"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}